import { NgModule } from '@angular/core';
import { environment } from '@fantaz/shared/app-config';
import { ZENDESK_CONFIG } from '@fantaz/shared/config';
import { NgxZendeskWebwidgetConfig } from './ngx-zendesk-webwidget.model';
import { NgxZendeskWebwidgetModule } from './ngx-zendesk-webwidget.module';

export class ZendeskConfig extends NgxZendeskWebwidgetConfig {
  override lazyLoad = true;
  accountUrl = environment.zendeskDomain;
  timeout = ZENDESK_CONFIG.timeOut;
  callback = () => null;
}

@NgModule({
  imports: [NgxZendeskWebwidgetModule.forRoot(ZendeskConfig)],
  exports: [NgxZendeskWebwidgetModule],
})
export class ZendeskModule {}
